import useResizeObserver from "@react-hook/resize-observer";
import { useState, useLayoutEffect } from "react";
const UseResize = (target) => {
  const [size, setSize] = useState();

  useLayoutEffect(() => {
    setSize(target.current.getBoundingClientRect());
  }, [target]);

  // Where the magic happens
  useResizeObserver(target, (entry) => setSize(entry.contentRect));
  return size;
};
export default UseResize;
